import { CommercetoolsIcon } from 'components/atomic/atoms/icons/logos/commercetools'
import { ContentfulIcon } from 'components/atomic/atoms/icons/logos/contentful'
import { DatoCMSIcon } from 'components/atomic/atoms/icons/logos/datocms'
import { DgraphIcon } from 'components/atomic/atoms/icons/logos/dgraph'
import { GithubIcon } from 'components/atomic/atoms/icons/logos/github'
import { SaleorIcon } from 'components/atomic/atoms/icons/logos/saleor'
import { StrapiIcon } from 'components/atomic/atoms/icons/logos/strapi'
import { FederationIcon } from 'components/pages/features/edge-gateway/icons/federation'
import { OpenaiIcon } from 'components/pages/features/edge-gateway/icons/openai'
import { PostgresIcon } from 'components/pages/features/edge-gateway/icons/postgres'
import { ShopifyIcon } from 'components/pages/features/edge-gateway/icons/shopify'
import { Storyblok as StoryblokIcon } from 'components/pages/features/edge-gateway/icons/storyblok'
import { StripeIcon } from 'components/pages/features/edge-gateway/icons/stripe'
import { TinybirdIcon } from 'components/pages/features/edge-gateway/icons/tinybird'

const templatesUrl = 'https://github.com/grafbase/grafbase/tree/main/templates'

export const templates = [
  {
    name: 'Federation',
    slug: 'federation',
    icon: FederationIcon,
    gitRepoUrl: templatesUrl + '/federated',
    envVars: [],
  },
  {
    name: 'Postgres',
    slug: 'postgres',
    icon: PostgresIcon,
    gitRepoUrl: templatesUrl + '/postgres',
    envVars: ['DATABASE_URL'],
  },
  {
    name: 'OpenAI',
    slug: 'openai',
    icon: OpenaiIcon,
    gitRepoUrl: templatesUrl + '/openapi-openai',
    envVars: [],
  },
  {
    name: 'Shopify',
    slug: 'shopify',
    icon: ShopifyIcon,
    gitRepoUrl: templatesUrl + '/graphql-shopify-storefront',
    envVars: ['SHOPIFY_API_URL', 'SHOPIFY_STOREFRONT_ACCESS_TOKEN'],
  },
  {
    name: 'commercetools',
    slug: 'commercetools',
    icon: CommercetoolsIcon,
    gitRepoUrl: templatesUrl + '/graphql-commercetools',
    envVars: ['COMMERCETOOLS_API_URL', 'COMMERCETOOLS_API_TOKEN'],
  },
  {
    name: 'Saleor',
    slug: 'saleor',
    icon: SaleorIcon,
    gitRepoUrl: templatesUrl + '/graphql-saleor',
    envVars: ['ENVIRONMENT_DOMAIN'],
  },
  {
    name: 'Stripe',
    slug: 'openapi-stripe',
    icon: StripeIcon,
    gitRepoUrl: templatesUrl + '/openapi-stripe',
    envVars: [],
  },
  {
    name: 'Contentful',
    slug: 'graphql-contentful',
    icon: ContentfulIcon,
    gitRepoUrl: templatesUrl + '/graphql-contentful',
    envVars: ['CONTENTFUL_API_URL'],
  },
  {
    name: 'Storyblok',
    slug: 'graphql-storyblok',
    icon: StoryblokIcon,
    gitRepoUrl: templatesUrl + '/graphql-storyblok',
    envVars: [],
  },
  {
    name: 'Strapi Cloud',
    slug: 'graphql-strapi',
    icon: StrapiIcon,
    gitRepoUrl: templatesUrl + '/graphql-strapi',
    envVars: ['STRAPI_API_URL'],
  },
  {
    name: 'DatoCMS',
    slug: 'graphql-datocms',
    icon: DatoCMSIcon,
    gitRepoUrl: templatesUrl + '/graphql-datocms',
    envVars: [],
  },
  {
    name: 'Dgraph Cloud',
    slug: 'graphql-dgraph',
    icon: DgraphIcon,
    gitRepoUrl: templatesUrl + '/graphql-dgraph',
    envVars: ['DGRAPH_API_URL'],
  },
  {
    name: 'GitHub',
    slug: 'graphql-github',
    icon: GithubIcon,
    gitRepoUrl: templatesUrl + '/graphql-github',
    envVars: [],
  },
  {
    name: 'Tinybird',
    slug: 'openapi-tinybird',
    icon: TinybirdIcon,
    gitRepoUrl: templatesUrl + '/openapi-tinybird',
    envVars: ['TINYBIRD_API_SCHEMA'],
  },
]
